<template>
<div v-if="!loading">
  <select
    v-model="defaultRateAndTermId"
    class="form-control input-lg"
    required
    @change="handleSelectRateAndTerm($event)"
  >
    <option
      v-for="(item, index) in yearRates"
      :value="item.id"
      :key="index"
      name="rateAndTerm"
    >
      {{ item.label }}
    </option>
  </select>
</div>
</template>


<script>
import { mapActions, mapState } from 'vuex';
import { selectRateAndTermToDisplay } from '@/util';

export default {
  name: 'CustomRatesAndTermsForInvestor',
  props: {
    nt: {
      type: Object,
      required: true,
    },
    showDefaultValue: true,
    actionProvided: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      yearRates: [],
      defaultRateAndTermId: 0,
      loading: false,
    };
  },
  beforeMount() {
    this.loading = true;
    this.initializeData();
  },
  computed: {
    ...mapState('app', [
      'investmentsRestrictions',
    ]),
  },
  methods: {
    ...mapActions('app', [
      'getRateAndTermByGroup',
    ]),
    async initializeData() {
      const rateAndTermGroups = this.investmentsRestrictions.rateAndTermGroups;

      let rateAndTermGroup =
      rateAndTermGroups[this.nt.transaction.manageRateAndTermGroupsId] ||
      await this.getInvestmentOptions(
        this.nt.transaction.manageRateAndTermGroupsId,
      );

      if (rateAndTermGroup.overrideManageRateAndTermGroupsId) {
        rateAndTermGroup =
        rateAndTermGroups[rateAndTermGroup.overrideManageRateAndTermGroupsId] ||
        await this.getInvestmentOptions(
          rateAndTermGroup.overrideManageRateAndTermGroupsId,
        );
      }

      this.yearRates = rateAndTermGroup.investmentOptions;

      const { selected: displayRateAndTerm, isCustom: isCustomRateAndTerm } =
        selectRateAndTermToDisplay(this.nt, this.yearRates);

      if (isCustomRateAndTerm) {
        this.yearRates.push(displayRateAndTerm);
      }

      this.defaultRateAndTermId = displayRateAndTerm.id;
      this.$emit('setRateAndTerm', displayRateAndTerm);
      this.loading = false;
    },
    async getInvestmentOptions(manageRateAndTermGroupsId) {
      return this.getRateAndTermByGroup({
        manageRateAndTermGroupsId,
      }).then(data => ({
        overrideManageRateAndTermGroupsId: data.overrideManageRateAndTermGroupsId,
        investmentOptions: data.investmentOptions,
      }));
    },
    handleSelectRateAndTerm(e) {
      const rateAndTerm = this.yearRates.find(item => item.id === parseInt(e.target.value, 10));
      this.$emit('setRateAndTerm', rateAndTerm);
    },
  },
};
</script>


<style scoped>
select,
input {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// CustomRatesAndTermsForInvestor.vue?06ce34b4